// Symbole als SVG (24×24, Linienstärke wie die Schrift), statt Schriftzeichen wie ⏮ oder ⛶,
// die je nach System anders oder gar nicht dargestellt werden.
import { h, type VNode } from 'snabbdom';

const PATHS: Record<string, string> = {
  first: 'M6 5v14M19 5l-9 7 9 7z',
  prev: 'M16 5l-9 7 9 7z',
  next: 'M8 5l9 7-9 7z',
  last: 'M18 5v14M5 5l9 7-9 7z',
  flip: 'M7 4v14m0 0l-3-3m3 3l3-3M17 20V6m0 0l-3 3m3-3l3 3',
  fullscreen: 'M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5',
  close: 'M6 6l12 12M18 6L6 18',
  // untere Reiterleiste am Handy
  play: 'M9 20h6M10 20l1-6M14 20l-1-6M8 14h8M9 10a3 3 0 1 1 6 0c0 1.5-1 2.5-1.5 4h-3C10 12.5 9 11.5 9 10z',
  puzzle: 'M12 4a8 8 0 1 0 0 16a8 8 0 1 0 0-16zM12 8.5a3.5 3.5 0 1 0 0 7a3.5 3.5 0 1 0 0-7zM12 2v4M12 18v4M2 12h4M18 12h4',
  library: 'M5 4h4v16H5zM10 4h4v16h-4zM15.5 4.5l3.5 1-4 15-3.5-1z',
  analyse: 'M4 20V10M10 20V4M16 20v-7M22 20H2',
  more: 'M5 12h.01M12 12h.01M19 12h.01',
};
const FILLED = new Set(['prev', 'next']);

export type IconName = keyof typeof PATHS;

export function icon(name: IconName): VNode {
  const solid = FILLED.has(name);
  return h('svg.icon', { attrs: { viewBox: '0 0 24 24', width: 18, height: 18, 'aria-hidden': 'true', focusable: 'false' } }, [
    h('path', {
      attrs: {
        d: PATHS[name],
        fill: solid || name === 'first' || name === 'last' ? 'currentColor' : 'none',
        stroke: 'currentColor',
        'stroke-width': name === 'more' ? 3.2 : 1.8, // Punkte für „Mehr“ kräftiger
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
      },
    }),
  ]);
}
